import React, { Component } from "react";
import { Row, Col, Label } from "reactstrap";
import Loader from "../Loader";
import { makeRequestAuth } from "../../utils/globals";
import RechargeOtpModal from "../../components/Modals/RechargeOtpModal";
import { phone_codes } from "../../utils/locales";
import profileService from "../../services/profileService";
import "./addCompanyAddressForm.scss";
import DropdownIndicator from "../../modules/Accounts/PlatformPreferences/Component/DropdownIndicator";
import { MOBILE_NO_ERROR } from "../../constants/AppConstant";
import { EditInfoInput } from "../../modules/Accounts/PlatformPreferences/Component/styled";
import {
  Dropdown,
  Icon,
  Input,
  Tooltip,
  Typography,
} from "@plum-xoxo/admin-dsm";

class AddCompanyAddressForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      phone_codes_ui: [],
      isd_code: "",
      errorMsg: "",
      error: false,
      defaultIsdCode: "+91",
      showOtpModal: false,
      otpValue: "",
      otp_id: null,
      showResendMsg: false,
      invalidOtpMsg: false,
      otpAutoFocusTrigger: false,
      showOtpLoading: false,
      addFundsLoader: false,
      addAmount: 0,
      userBalanceAfterRecharge: 0,
    };
  }

  componentDidMount() {
    const {
      accountReducer: {
        employeeDetails: { employee_primary_mobile = "" } = {},
      } = {},
    } = this.props;
    const splitNum = employee_primary_mobile.split("-");
    const employeePhnNum = splitNum.length > 1 ? splitNum[1] : "";
    const phone_codes_ui =
      phone_codes &&
      phone_codes.map((item) => {
        let obj = item;
        obj.label = item.iso + " " + item.phonecode;
        obj.value = item.country_id;
        return obj;
      });
    this.props.setPaymentState &&
      this.props.setPaymentState({
        nonVerifiedPhoneNumber: employeePhnNum,
      });
    this.setState({ phone_codes_ui: phone_codes_ui });
    this.getDefaultIsd(phone_codes_ui);
  }

  handleISDchange = (event) => {
    this.props.setPaymentState({
      nonVerifiedIsdCodeObject: event,
      isd_code: event.phonecode,
      error: false,
      errorMsg: "",
    });
  };
  handleMobileChange = (event) => {
    if (event && event.target) {
      let phnNum = event.target.value;
      let reg = /^\d+$/;

      if (
        !(phnNum.length == 0 && phnNum == "") &&
        (!reg.test(phnNum) || parseInt(phnNum) == 0)
      ) {
        return;
      }
      if (phnNum.length > 16) {
        return;
      }
      this.props.setPaymentState({
        phnNumError: false,
        nonVerifiedPhoneNumber: phnNum ? phnNum : "",
      });
    }
  };

  getDefaultIsd = (phone_codes_ui) => {
    profileService.fetchCountryBasedonIP().then((response) => {
      if (response && response.plumApi && response.plumApi.output) {
        let { employeeDetails: { employee_primary_mobile } = {} } = this.props;
        const splitNum = employee_primary_mobile?.split("-");
        const employeePhnCode = splitNum?.length >= 1 ? splitNum[0] : "";
        if (employeePhnCode === "") {
          const ipBasedOutput = JSON.parse(response.plumApi.output);
          let countryCode = "IN";
          if (ipBasedOutput.success && ipBasedOutput.success === 1) {
            countryCode = ipBasedOutput.country_code;
          }
          const phonecodeDetails = phone_codes_ui.find(
            (item) => item.iso == countryCode
          );
          this.props.setPaymentState &&
            this.props.setPaymentState({
              nonVerifiedIsdCodeObject: phonecodeDetails,
            });
        } else {
          const phonecodeDetails = phone_codes_ui.find(
            (item) => item.phonecode == employeePhnCode
          );
          this.props.setPaymentState &&
            this.props.setPaymentState({
              nonVerifiedIsdCodeObject: phonecodeDetails,
            });
        }
      }
    });
  };

  handleResendOtp = () => {
    const { nonVerifiedIsdCodeObject, nonVerifiedPhoneNumber, otp_id } =
      this.props;

    const otpParams = {
      otp_id: otp_id || "",
      isd_code: nonVerifiedIsdCodeObject?.phonecode,
      phone_number: nonVerifiedPhoneNumber,
    };

    const options = {
      query: "storesAdmin.query.resendOtp",
      tag: "storeAdmin",
      variables: {
        otp_resend_data: otpParams,
      },
    };

    makeRequestAuth(
      options,
      function (response) {
        if (
          response &&
          response.data &&
          response.data.resendOtp &&
          response.data.resendOtp.success === 1
        ) {
          this.setState({ showResendMsg: true, invalidOtpMsg: false });
        }
      }.bind(this)
    );
  };

  handleValidateOtp = () => {
    const { otpValue } = this.state;
    const { nonVerifiedPhoneNumber, nonVerifiedIsdCodeObject } = this.props;
    this.setState({ showOtpLoading: true });
    const otpParams = {
      isd_code: nonVerifiedIsdCodeObject.phonecode,
      phone_number: nonVerifiedPhoneNumber,
      otp_id: this.props.otp_id,
      otp: otpValue,
    };

    const options = {
      query: "storesAdmin.query.validateRechargeOtp",
      tag: "storeAdmin",
      variables: {
        add_data: otpParams,
      },
    };
    makeRequestAuth(
      options,
      function (response) {
        if (
          response &&
          response.data &&
          response.data.validateRechargeOtp &&
          response.data.validateRechargeOtp.success === 1
        ) {
          this.setState({ showOtpLoading: false });
          this.props.setPaymentState(
            {
              rechargeState: {
                phnNum: nonVerifiedPhoneNumber,
                isd_code_obj: nonVerifiedIsdCodeObject,
                ...this.props.rechargeState,
              },
              showOtpModal: false,
            },
            this.props.submitAddressDetails
          );
        } else {
          this.setState({
            invalidOtpMsg: true,
            showResendMsg: false,
            showOtpLoading: false,
            otpAutoFocusTrigger: true,
            otpValue: "",
          });
        }
      }.bind(this)
    );
  };
  customStyles = {
    control: (base, state) => ({
      ...base,
      height: "58px",
      minHeight: "58px",
      maxHeight: "58px",
      border: state.isFocused ? "1px solid #BAC7D5" : "1px solid #BAC7D5",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#BAC7D5",
        boxShadow: "0",
      },
      borderRight: 0,
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
    }),
  };
  render() {
    const {
      loader,
      companyAddress,
      countryOption,
      cityOption,
      stateOption,
      selectedCountry,
      selectedState,
      selectedCity,
      loading,
      errorCompanyAddress,
      handleInputChange,
      isProfileUpdate = false,
      kybStatus,
      role,
      xs = "6",
      showOtpModal,
      nonVerifiedIsdCodeObject,
      nonVerifiedPhoneNumber,
      currencyCode,
      countriesLoading,
      statesLoading,
      citiesLoading,
    } = this.props;
    const {
      otpValue,
      otp_id,
      showResendMsg,
      invalidOtpMsg,
      otpAutoFocusTrigger,
      showOtpLoading,
      phone_codes_ui,
    } = this.state;

    const isDisabled =
      isProfileUpdate && (kybStatus.kyb_status == 2 || role === 100);
    return (
      <>
        {loader ? (
          <Loader />
        ) : (
          <>
            {!this.props.rechargeState?.phnNum && this.props.setPaymentState ? (
              <>
                <Row>
                  <Col xs="12">
                    <h6>Mobile number</h6>
                  </Col>
                </Row>
                <Col xs={xs} className="mb-22">
                  <div className="float-labelX">
                    <Row>
                      <Col xs={2} className="m-0 p-0">
                        <Dropdown
                          options={phone_codes_ui}
                          value={nonVerifiedIsdCodeObject}
                          isSearchable={true}
                          onChange={(event) => {
                            this.handleISDchange(event);
                          }}
                          components={{
                            IndicatorSeparator: () => null,
                            DropdownIndicator,
                          }}
                          placeholder=""
                          noOptionsMessage={() => {
                            return "No Code";
                          }}
                        />
                      </Col>
                      <Col className="m-0 p-0 ml-4">
                        <Input
                          placeholder="Enter company contact number"
                          onChange={(e) => this.handleMobileChange(e)}
                          value={nonVerifiedPhoneNumber}
                          className={
                            this.props.phnNumError
                              ? "amountInput1 error"
                              : "amountInput1 mobileInput"
                          }
                          id="company_number"
                          style={{ fontSize: "16px" }}
                          helperText={
                            currencyCode === "INR"
                              ? "We’ll send an OTP for verification"
                              : ""
                          }
                        />
                      </Col>
                    </Row>
                  </div>
                </Col>
                {this.props.phnNumError ? (
                  <Label className="error">{MOBILE_NO_ERROR}</Label>
                ) : null}
              </>
            ) : null}

            <EditInfoInput
              className="w-100 mb-20"
              label="Registered Business Address"
              placeholder="Enter full business address"
              value={companyAddress.company_address1}
              onChange={(e) => {
                handleInputChange("company_address1", e);
              }}
              error={errorCompanyAddress.company_address1}
              helperText={
                errorCompanyAddress.company_address1 &&
                errorCompanyAddress.company_address1
              }
            />
            <Typography
              component="div"
              className="d-flex w-100"
              style={{
                gap: "20px",
              }}
            >
              <Typography component="div" className="w-50 mb-20">
                <Dropdown
                  options={countryOption}
                  isDisabled={isDisabled}
                  onChange={(e) => {
                    handleInputChange("country", e);
                  }}
                  placeholder={"Select country"}
                  value={selectedCountry}
                  label="Country"
                  error={errorCompanyAddress.country_id}
                  helperText={
                    errorCompanyAddress.country_id && (
                      <Dropdown.HelperText>
                        {errorCompanyAddress.country_id}
                      </Dropdown.HelperText>
                    )
                  }
                  isLoading={countriesLoading}
                />
              </Typography>
              <Typography component="div" className="w-50 mb-20">
                <Dropdown
                  options={stateOption}
                  isDisabled={isDisabled}
                  onChange={(e) => {
                    handleInputChange("state", e);
                  }}
                  placeholder={"Select state"}
                  value={selectedState}
                  label="State"
                  className="ml-3"
                  error={errorCompanyAddress.state_id}
                  helperText={
                    errorCompanyAddress.state_id && (
                      <Dropdown.HelperText>
                        {errorCompanyAddress.state_id}
                      </Dropdown.HelperText>
                    )
                  }
                  isLoading={statesLoading}
                />
              </Typography>
            </Typography>
            <Typography
              component="div"
              className="d-flex w-100"
              style={{
                gap: "20px",
              }}
            >
              <Typography component="div" className="w-50">
                <Dropdown
                  options={cityOption}
                  value={selectedCity}
                  isDisabled={isDisabled}
                  onChange={(e) => {
                    handleInputChange("city", e);
                  }}
                  placeholder={"Select city"}
                  label="City"
                  error={errorCompanyAddress.city_id}
                  helperText={
                    errorCompanyAddress.city_id && (
                      <Dropdown.HelperText>
                        {errorCompanyAddress.city_id}
                      </Dropdown.HelperText>
                    )
                  }
                  isLoading={citiesLoading}
                />
              </Typography>
              <Typography component="div" className="w-50">
                <EditInfoInput
                  className="w-100 pl-3"
                  label="Postal Code"
                  placeholder="Enter postal code"
                  value={companyAddress.zip_code}
                  disabled={isDisabled}
                  onChange={(e) => {
                    handleInputChange("zipcode", e);
                  }}
                  error={errorCompanyAddress.zip_code && true}
                  helperText={
                    errorCompanyAddress.zip_code && errorCompanyAddress.zip_code
                  }
                  maxLength={8}
                />
              </Typography>
            </Typography>
            {!isProfileUpdate ? (
              <Typography component="div" className="w-100 mt-20">
                <EditInfoInput
                  className="w-100"
                  label="Business Registration Number (BRN)"
                  error={errorCompanyAddress.taxId}
                  value={companyAddress.taxId}
                  onChange={(e) => handleInputChange("taxId", e)}
                  placeholder={
                    "Eg: GST, TAX ID, VAT, EIN, regsitration no, DUNS etc."
                  }
                  endIcon={
                    <>
                      <Tooltip
                        tooltip={
                          errorCompanyAddress.taxId
                            ? errorCompanyAddress.taxId
                            : `A Business Registration Number is a unique number that is
                assigned by your government authorities. Such as: GST, TAX ID,
                VAT, EIN, regsitration no, DUNS etc.`
                        }
                        width={300}
                      >
                        <Icon iconName="Info" />
                      </Tooltip>
                    </>
                  }
                />
              </Typography>
            ) : null}

            {/* <Row>
              <Col
                xs="12"
                className={!this.props.rechargeState?.phnNum ? "mt-4" : ""}
              >
                <h6>Registered Company Address</h6>
              </Col>
            </Row>
            <Row>
              <Col xs={xs} className="mb-3">
                <div className="float-labelX">
                  <Input
                    className={"modalInput mobile"}
                    id="companyAddress1"
                    disabled={
                      companyAddress.company_address1 != "" && isDisabled
                    }
                    value={companyAddress.company_address1}
                    onChange={(e) => {
                      handleInputChange("company_address1", e);
                    }}
                    placeholder="Enter your company’s full address"
                    style={{ fontSize: "16px" }}
                  />
                </div>
                {errorCompanyAddress.company_address1 ? (
                  <Label className="error">
                    {errorCompanyAddress.company_address1}
                  </Label>
                ) : null}
              </Col>
            </Row>
            <Row>
              <Col xs={xs / 2} className="mb-3 pr-3">
                {isDisabled ? (
                  <div className="float-labelX">
                    <Input
                      className="modalInput mobile"
                      value={(selectedCountry && selectedCountry.name) || ""}
                      disabled
                    />
                  </div>
                ) : (
                  <div className="float-label">
                    <Select
                      textFieldProps={{
                        label: "",
                        InputLabelProps: {
                          shrink: true,
                        },
                      }}
                      id="country"
                      isLoading={loading}
                      options={countryOption}
                      isDisabled={isDisabled}
                      onChange={(e) => {
                        handleInputChange("country", e);
                      }}
                      placeholder={"Select Country"}
                      value={selectedCountry}
                      isSearchable={true}
                      className={"modalInput"}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          neutral50: "#BAC7D5",
                        },
                      })}
                    />
                  </div>
                )}
                {errorCompanyAddress.country_id ? (
                  <Label className="error">
                    {errorCompanyAddress.country_id}
                  </Label>
                ) : null}
              </Col>
              <Col xs={xs / 2} className="mb-3 pl-0">
                {isDisabled ? (
                  <div className="float-labelX">
                    <Input
                      className="modalInput mobile"
                      value={(selectedState && selectedState.name) || ""}
                      disabled
                    />
                  </div>
                ) : (
                  <div className="float-label">
                    <Select
                      textFieldProps={{
                        InputLabelProps: {
                          shrink: false,
                        },
                      }}
                      id=""
                      isLoading={loading}
                      options={stateOption}
                      isDisabled={isDisabled}
                      onChange={(e) => {
                        handleInputChange("state", e);
                      }}
                      placeholder={"Select State"}
                      value={selectedState}
                      isSearchable={true}
                      className={"modalInput"}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          neutral50: "#BAC7D5",
                        },
                      })}
                    />
                  </div>
                )}

                {errorCompanyAddress.state_id ? (
                  <Label className="error">
                    {errorCompanyAddress.state_id}
                  </Label>
                ) : null}
              </Col>
            </Row>
            <Row>
              <Col xs={xs / 2} className="mb-3 pr-3">
                {isDisabled ? (
                  <div className="float-labelX">
                    <Input
                      className="modalInput mobile"
                      value={(selectedCity && selectedCity.name) || ""}
                      disabled
                    />
                  </div>
                ) : (
                  <div className="float-label">
                    <Select
                      textFieldProps={{
                        label: "",
                        InputLabelProps: {
                          shrink: false,
                        },
                      }}
                      id="city"
                      isLoading={loading}
                      options={cityOption}
                      value={selectedCity}
                      isDisabled={isDisabled}
                      onChange={(e) => {
                        handleInputChange("city", e);
                      }}
                      placeholder={"Select City"}
                      isSearchable={true}
                      className={"modalInput"}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          neutral50: "#BAC7D5", // Placeholder color
                        },
                      })}
                    />
                  </div>
                )}

                {errorCompanyAddress.city_id ? (
                  <Label className="error">{errorCompanyAddress.city_id}</Label>
                ) : null}
              </Col>
              <Col xs={xs / 2} className="pl-0">
                <div className="float-labelx">
                  <Input
                    className={"modalInput mobile"}
                    id="zipcode"
                    placeholder="Postal Code"
                    value={companyAddress.zip_code}
                    disabled={isDisabled}
                    onChange={(e) => {
                      handleInputChange("zipcode", e);
                    }}
                    style={{ fontSize: "16px" }}
                  />
                </div>
                {errorCompanyAddress.zip_code ? (
                  <Label className="error">
                    {errorCompanyAddress.zip_code}
                  </Label>
                ) : null}
              </Col>
            </Row> */}
            {/* {!isProfileUpdate ? (
              <>
                <Row>
                  <Col xs={xs} className="mt-4">
                    <h6>
                      Business Identification number{" "}
                      <CustomTooltip
                        id={`tip-bin`}
                        tiptext={`A business identification number is a unique number that is
                                    assigned by your government authorities. Such as: GST, TAX ID,
                                    VAT, EIN, regsitration no, DUNS etc.`}
                        showtext={
                          <img
                            id="businessIdentification"
                            src="/admin/img/svg-icons/info-circle-gray.svg"
                          />
                        }
                        position="top"
                      />
                    </h6>
                  </Col>
                </Row>
                <Row>
                  <Col xs={xs} className="mb-3 ">
                    <div>
                      <Row>
                        <Col xs="12" className="mb-3">
                          <Input
                            className={"modalInput mobile"}
                            value={companyAddress.taxId}
                            onChange={(e) => handleInputChange("taxId", e)}
                            placeholder={
                              "Eg: GST, TAX ID, VAT, EIN, regsitration no, DUNS etc."
                            }
                            name={"taxId"}
                            id="taxId"
                            //style={{ paddingTop: "30px" }}
                          />
                          {errorCompanyAddress.taxId ? (
                            <Label className="error">
                              {errorCompanyAddress.taxId}
                            </Label>
                          ) : null}
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </>
            ) : null} */}
            {showOtpModal ? (
              <RechargeOtpModal
                closeModal={() => {
                  this.setState({
                    invalidOtpMsg: false,
                    showResendMsg: false,
                  });
                  this.props.setPaymentState({ showOtpModal: false });
                }}
                updateOtp={(otp) =>
                  this.setState({
                    otpValue: otp,
                    invalidOtpMsg: false,
                    showResendMsg: false,
                  })
                }
                otpValue={otpValue}
                isd_code_object={nonVerifiedIsdCodeObject}
                validateOtp={() => this.handleValidateOtp()}
                resendOtp={() => this.handleResendOtp()}
                otp_id={otp_id}
                phnNumber={nonVerifiedPhoneNumber}
                showResendMsg={showResendMsg}
                invalidOtpMsg={invalidOtpMsg}
                otpAutoFocusTrigger={otpAutoFocusTrigger}
                showOtpLoading={showOtpLoading}
                triggerFocus={(data) =>
                  this.setState({ otpAutoFocusTrigger: data })
                }
                showOtpModal={showOtpModal}
              />
            ) : null}
          </>
        )}
      </>
    );
  }
}

export default AddCompanyAddressForm;
